// extracted by mini-css-extract-plugin
export default {"text":"lvBGWOOW_Cmy2icV941A","tableWrapper":"zPx2CdeUlo66q5jHTev0"};